
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.592","height":"13.5","viewBox":"0 0 21.592 13.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_1186","transform":"translate(0 -85.333)"}},[_c('path',{attrs:{"id":"Path_2116","d":"M20.017 88.033H19.8v-.225a2.478 2.478 0 00-2.475-2.475H2.475A2.478 2.478 0 000 87.808v8.55a2.478 2.478 0 002.475 2.475h14.85a2.478 2.478 0 002.475-2.475v-.225h.217a1.577 1.577 0 001.575-1.575v-4.95a1.577 1.577 0 00-1.575-1.575zm.225 6.525a.225.225 0 01-.225.225h-.892a.675.675 0 00-.675.675v.9a1.127 1.127 0 01-1.125 1.125H2.475a1.127 1.127 0 01-1.125-1.125v-8.55a1.127 1.127 0 011.125-1.125h14.85a1.127 1.127 0 011.125 1.125v.9a.675.675 0 00.675.675h.892a.225.225 0 01.225.225z"}}),_c('path',{attrs:{"id":"Path_2117","d":"M77.725 157.433h-13.05a.675.675 0 01-.675-.675v-6.75a.675.675 0 01.675-.675h13.05a.675.675 0 01.675.675v6.75a.675.675 0 01-.675.675z","transform":"translate(-61.3 -61.3)","fill":"#68b612"}})])])
          )
        }
      }
    